import { Outlet } from 'react-router';

/**
 * Schil voor de publieke klantpagina.
 *
 * Bewust kaal. De klantpagina draait volledig in de huisstijl van het
 * keuringsbedrijf, en de koper ziet alleen dat bedrijf: Smartkeur staat nergens
 * op de pagina, ook niet in de voet. Zet hier dus geen kopbalk, logo, navigatie
 * of afsluitende tekst omheen.
 *
 * Het enige wat deze schil doet, is het vlak achter het rapportpaneel vullen.
 */
export function PublicLayout() {
    return (
        <div
            style={{
                minBlockSize: '100%',
                background: 'var(--surface-board)',
            }}
        >
            <Outlet />
        </div>
    );
}
